module.exports = __webpack_public_path__ + "static/media/MasterBed1-2.756c57d2.jpg";